import styled from 'styled-components'
import ViiluFullPageDialog from 'ui/components/ViiluFullPageDialog'
import { useIntl } from 'react-intl'
import { Button } from 'react-md'
import { FormProvider, useForm } from 'react-hook-form'
import { useZodValidationResolver } from 'util/hooks/useZodValidationResolver'
import type { FormInputs } from './validation'
import { basicInformationFormSchema } from './validation'
import VoucherForm from './VoucherForm'
import VoucherFormTable from './VoucherFormTable'
import type { Vat } from './types'
import useVoucher from './useVoucher'
import { useEffect } from 'react'

const Wrapper = styled.div`
	height: 100%;
	overflow: auto;
`

const Content = styled.div`
	overflow: auto;
	min-height: 60vh;
`

type VoucherDialogProps = {
	companyUUID?: string
	databaseSource?: string
	voucherId?: number
	vats?: Vat[]
	refresh: () => void
	onHide?: () => void
	onHideURL?: string
}

const VoucherDialog = (props: VoucherDialogProps) => {
	const { companyUUID, databaseSource, voucherId, vats, onHide, onHideURL } =
		props
	const intl = useIntl()

	const resolver = useZodValidationResolver<FormInputs>(
		basicInformationFormSchema(intl),
	)

	const { voucher } = useVoucher({
		companyUUID,
		databaseSource,
		voucherId,
	})

	const formMethods = useForm<FormInputs>({
		resolver,
		defaultValues: { ...voucher },
		mode: 'onBlur',
		shouldUnregister: false,
	})

	useEffect(() => {
		formMethods.reset(voucher || {})
	}, [formMethods, voucher])

	const renderContent = () => {
		return (
			<Wrapper>
				<FormProvider {...formMethods}>
					<Content>
						<VoucherForm />

						<VoucherFormTable vats={vats} />
					</Content>
				</FormProvider>
			</Wrapper>
		)
	}

	const actions: JSX.Element[] = [
		<Button style={{ marginRight: '5px' }} raised secondary onClick={() => {}}>
			{intl.formatMessage({
				defaultMessage: 'Hyväksy',
				description: 'Label for the button.',
			})}
		</Button>,
		<Button style={{ marginRight: '5px' }} raised secondary onClick={() => {}}>
			{intl.formatMessage({
				defaultMessage: 'Tallenna & sulje',
				description: 'Label for the button.',
			})}
		</Button>,
	]

	return (
		<ViiluFullPageDialog
			id="voucher-dialog"
			title={
				voucherId
					? intl.formatMessage({
							defaultMessage: 'Muokkaa tositetta',
							description: 'Title for voucher dialog',
					  })
					: intl.formatMessage({
							defaultMessage: 'Luo tosite',
							description: 'Title of create voucher dialog',
					  })
			}
			visible
			onHide={onHide}
			onHideURL={onHideURL}
			focusOnMount={false}
			toolbarStyle={{
				background: 'var(--color-secondary-dark)',
			}}
			navActions={actions}
		>
			{renderContent()}
		</ViiluFullPageDialog>
	)
}

export default VoucherDialog
